import { createContext, useContext } from "react";

/**
 * Shared between PageShell (chrome + page-overlay modules) and ModularPage
 * (the page's own body modules) so both can open the SAME quick-edit
 * dialog, without each needing to fetch `allPages` or manage dialog state
 * independently.
 */
export const EditModeContext = createContext({
  editMode: false,
  openEditor: () => {},
});

export const useEditModeContext = () => useContext(EditModeContext);
